var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsersSm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "users",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.984,
    height: 12.787,
    viewBox: "0 0 15.984 12.787",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4506",
    "data-name": "Path 4506",
    d: "M132.8,132.8a2.4,2.4,0,1,0-2.4-2.4A2.4,2.4,0,0,0,132.8,132.8Zm-1.466.8A3.33,3.33,0,0,0,128,136.924a.667.667,0,0,0,.667.667h8.257a.667.667,0,0,0,.667-.667,3.33,3.33,0,0,0-3.329-3.329Z",
    transform: "translate(-124.803 -124.803)",
    fill: "#047BC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4507",
    "data-name": "Path 4507",
    d: "M5.594,2a2,2,0,1,0-2,2,2,2,0,0,0,2-2Zm9.191,0a2,2,0,1,0-2,2,2,2,0,0,0,2-2ZM2.665,4.8A2.666,2.666,0,0,0,0,7.46a.534.534,0,0,0,.532.532H5.879A3.189,3.189,0,0,1,4.8,5.594a3.421,3.421,0,0,1,.047-.557A2.641,2.641,0,0,0,3.731,4.8Zm7.443,3.2h5.345a.532.532,0,0,0,.532-.532A2.666,2.666,0,0,0,13.319,4.8H12.255a2.679,2.679,0,0,0-1.114.242,3.143,3.143,0,0,1,.047.557A3.2,3.2,0,0,1,10.108,7.992Z",
    fill: "#888",
    opacity: 0.8
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsersSm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/users-sm.7e35be5365c51af5fdafd47bb6fd3f21.svg";